<template>
  <div>
    <b-overlay
        :show="!isReady"
        rounded="sm"
        bg-color="white"
    >
      <b-card
          v-if="isReady"
          class="text-center"
      >
        <b-avatar
            class="mb-1"
            :variant="'light-'+color"
            size="45"
        >
          <icon
              :icon="icon"
              size="2x"
          />
        </b-avatar>
        <div class="truncate">
          <h2 class="mb-25 font-weight-bolder text-truncate">
            {{ capitalize($t(title)) }}
          </h2>
          <span>{{ value }}</span>
        </div>

        <div v-if="evolution" class="mt-2">
          <indicator-evolution-pill
              :indicator="evolution"
          />
        </div>
      </b-card>
      <b-card v-else>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import IndicatorEvolutionPill   from '../../../../../components/indicatorEvolution/IndicatorEvolutionPill.vue'
import { capitalize }           from '../../../../../utils/filter'

export default {
  components: { IndicatorEvolutionPill },
  props: {
    isReady: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    evolution: {
      type: Number
    }
  },
  setup () {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: { capitalize },
  mounted () {
  },
  created () {
  }
}
</script>

<style
    scoped
    lang="scss"
>

</style>